import { render, staticRenderFns } from "./BsMenu.vue?vue&type=template&id=787ee2e0&"
import script from "./BsMenu.vue?vue&type=script&lang=js&"
export * from "./BsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BsMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports